import { useEffect, useRef, useState } from "react";
import { Stage, Layer } from "react-konva";
import Marking from "./Marking";

const screenHeightRatio = 9 / 16;

// The reference model of a photo group with the markings on top of it.
const ImageCanvas = ({ imageUrl, markings, onChangeKordinat, disabled }) => {
  const bgDivRef = useRef(null);

  const [size, setSize] = useState({ width: 1, height: 1 });

  useEffect(() => {
    if (bgDivRef.current) {
      const boundingRect = bgDivRef.current.getBoundingClientRect();
      const { width, height } = boundingRect;
      setSize({ width: Math.round(width), height: Math.round(height) });
    }
  }, [bgDivRef, bgDivRef.current]);

  return (
    <div ref={bgDivRef} className="col-start-start relative bg-red-100 w-full">
      <img
        src={imageUrl}
        alt="gambar"
        className={`absolute top-0 left-0 object-fill w-full h-full`}
      />
      {size.width > 50 && (
        <Stage
          width={size.width}
          height={Math.floor(size.width * screenHeightRatio)}
        >
          <Layer>
            {markings.map((el) => {
              return (
                <Marking
                  key={`${el.id || el._localId}-${Math.random()
                    .toString(36)
                    .substr(2, 9)} `}
                  parent_width={size.width}
                  parent_height={size.height}
                  data={el}
                  index={el.urutan}
                  onChangeKordinat={onChangeKordinat}
                  disabled={disabled}
                />
              );
            })}
          </Layer>
        </Stage>
      )}
    </div>
  );
};

export default ImageCanvas;
